export enum SurveyQuestionModalMode {
  CREATE = "CREATE",
  EDIT = "EDIT",
}
